"use client";
import { useRef as u, useCallback as d, useEffect as i } from "react";
function v(m = {}) {
  const { threshold: a = 150, interactionTimeout: f = 150 } = m, r = u(null), h = u(!0), s = u(!1), l = d(() => {
    const t = r.current;
    return t ? t.scrollHeight - t.clientHeight - t.scrollTop < a : !1;
  }, [a]), o = d((t = !1) => {
    const e = r.current;
    !e || s.current || e.scrollTo({
      top: e.scrollHeight,
      behavior: t ? "smooth" : "auto"
    });
  }, []);
  return i(() => {
    const t = r.current;
    if (!t) return;
    let e;
    const n = () => {
      s.current = !0, h.current = l(), window.clearTimeout(e), e = window.setTimeout(() => {
        s.current = !1;
      }, f);
    };
    return t.addEventListener("scroll", n, { passive: !0 }), () => {
      t.removeEventListener("scroll", n), window.clearTimeout(e);
    };
  }, [l, f]), i(() => {
    const t = r.current;
    if (!t) return;
    const e = new MutationObserver((n) => {
      n.some(
        (c) => c.type === "childList" || c.type === "characterData" || c.type === "attributes" && c.attributeName === "style"
      ) && h.current && o(!0);
    });
    return e.observe(t, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"],
      // Only watch style changes
      characterData: !0
    }), () => e.disconnect();
  }, [o]), i(() => {
    r.current && o();
  }, [o]), {
    containerRef: r,
    scrollToBottom: o,
    isNearBottom: l
  };
}
export {
  v as useScrollToBottom
};
